import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft, ShieldCheck, FileText, Activity, Lock } from "lucide-react";
import { legale, LEGALE_VERSIONE, LEGALE_DATA } from "@/data/legale";

const ICONE = { termini: FileText, privacy: ShieldCheck, stato: Activity, sicurezza: Lock };

export default function Legale({ tipo = "termini" }) {
  const { lang } = useI18n();
  const doc = legale(lang)[tipo];
  const Icona = ICONE[tipo] || FileText;
  const it = lang === "it";

  const stampa = () => {
    const w = window.open("", "_blank", "width=760,height=900");
    if (!w) return;
    const body = doc.sezioni
      .map(
        (s, i) => `<h2 style="margin:20px 0 6px;font-size:15px">${i + 1}. ${s.t}</h2>
        <ul style="margin:0;padding-left:18px">${s.p.map((x) => `<li style="margin-bottom:5px">${x}</li>`).join("")}</ul>`,
      )
      .join("");
    w.document.write(`<html><head><title>${doc.titolo}</title></head>
      <body style="font-family:Helvetica,Arial,sans-serif;font-size:12px;line-height:1.55;color:#0f172a;padding:28px;max-width:720px;margin:auto">
      <h1 style="font-size:20px;margin:0">Reprehendo (RH) · ${doc.titolo}</h1>
      <p style="color:#64748b;margin:4px 0 16px">${it ? "Versione" : "Version"} ${LEGALE_VERSIONE} · ${it ? "in vigore dal" : "in force since"} ${LEGALE_DATA}</p>
      <p>${doc.intro}</p>${body}</body></html>`);
    w.document.close();
    w.print();
  };

  return (
    <div className="min-h-screen bg-slate-950 px-5 py-10 text-slate-200" data-testid={`legal-page-${tipo}`}>
      <div className="mx-auto max-w-3xl">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <a href="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 transition-colors hover:text-amber-400" data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" /> {it ? "Torna al sito" : "Back to the site"}
          </a>
          <Button variant="outline" size="sm" className="border-slate-700 bg-transparent text-slate-300 hover:bg-slate-800" onClick={stampa} data-testid="legal-print-btn">
            <Printer className="mr-1.5 h-4 w-4" /> {it ? "Stampa o salva in PDF" : "Print or save as PDF"}
          </Button>
        </div>

        <div className="mt-8 flex items-start gap-3">
          <span className="mt-1 rounded-lg bg-amber-500/10 p-2 text-amber-400">
            <Icona className="h-5 w-5" />
          </span>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">Reprehendo (RH)</p>
            <h1 className="mt-1 font-head text-3xl font-bold tracking-tight text-white sm:text-4xl">{doc.titolo}</h1>
            <p className="mt-1 text-xs text-slate-500">
              {it ? "Versione" : "Version"} {LEGALE_VERSIONE} · {it ? "in vigore dal" : "in force since"} {LEGALE_DATA}
            </p>
          </div>
        </div>

        <p className="mt-6 border-l-2 border-amber-500/60 pl-4 text-base text-slate-300">{doc.intro}</p>

        <div className="mt-10 space-y-8">
          {doc.sezioni.map((s, i) => (
            <section key={s.t} data-testid={`legal-section-${i + 1}`}>
              <h2 className="font-head text-base font-bold text-white md:text-lg">
                {i + 1}. {s.t}
              </h2>
              <ul className="mt-2 space-y-2 text-sm leading-relaxed text-slate-400">
                {s.p.map((x) => (
                  <li key={x} className="flex gap-2">
                    <span className="text-amber-500/60">·</span>
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-4 border-t border-slate-800 pt-6 text-xs text-slate-500">
          <a href="/termini" className="hover:text-amber-400">{it ? "Condizioni di utilizzo" : "Terms of use"}</a>
          <a href="/privacy" className="hover:text-amber-400">{it ? "Informativa privacy" : "Privacy notice"}</a>
          <a href="/stato" className="hover:text-amber-400">{it ? "Stato del servizio" : "Service status"}</a>
        </div>
      </div>
    </div>
  );
}
